// Stesso bundle che usa widget.js, servito dal backend (vedi
// apps/backend/src/vendor/deep-chat): le anteprime dell'editor girano sulla
// stessa versione dei widget in produzione. Versione da tenere allineata a
// DEEP_CHAT_VERSION del backend.
const DEEP_CHAT_VERSION = '2.5.1'
const DEEP_CHAT_SRC = `${import.meta.env.VITE_API_BASE_URL}/public/vendor/deep-chat/${DEEP_CHAT_VERSION}/deepChat.bundle.js`

// Registra <deep-chat> se manca. Controllo su customElements.get e non sullo
// <script>: il tag può esistere con il modulo non ancora valutato. Non rigetta
// mai: se il bundle non arriva l'anteprima resta senza chat, non si rompe.
export function loadDeepChat() {
  if (customElements.get('deep-chat')) return Promise.resolve()
  return import(/* @vite-ignore */ DEEP_CHAT_SRC).catch(() => {})
}
